import e from "../createParser/index.mjs";
const r = e(/[A-Z]/, (o) => `-${o.toLowerCase()}`), t = e(/_/, () => "-");
export {
  r as camelToKebab,
  t as snakeToKebab
};
